<template>
<button :class="classes">
    {{msg}}
</button>
</template>

<script>
export default {
    props: ['msg', 'dark'],
    computed: {
        classes(){
            return this.dark ? ["button", "button-dark"] : ["button"]
        }
    }
}
</script>

<style lang="scss" scoped>
.button {
    padding: 20px;
    background-color: white;
    border: 2px solid #C5281C;
    cursor: pointer;
    height: 70px;
    color: #C5281C;
    font-weight: 600;
    transition: background-color 0.5s, color 0.5s;
    outline: none;
    min-width: 120px;

    &:hover {
        color: white;
        background-color: #C5281C;
    }

    &-dark {
        border: 2px solid black;
        color: black;

        &:hover {
            color: white;
            background-color: black;
        }
    }

}
</style>
